<!-- 轻量化监控  -->
<template>
  <div class="lightMonitoring">
    <el-form ref="searchForm" class="searchForm" :inline="true" :model="searchForm" size="small">
      <el-form-item label="上传时间:">
        <el-date-picker
          v-model="timeRange"
          size="small"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          @change="search"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="文件类型:">
        <el-select v-model="searchForm.fileTypes" size="small" multiple>
          <el-option v-for="item in typeList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文件名称:">
        <el-input v-model="searchForm.fileName" placeholder="请输入" size="small" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button type="primary" plain size="small" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- charts统计 -->
    <chartsData ref="chartsData" :searchForm="searchForm"></chartsData>
    <!-- 轻量化表单 -->
    <lightTable ref="lightTable" :searchForm="searchForm"></lightTable>
  </div>
</template>

<script>
import { mapState } from "vuex";
import chartsData from "@/CommonDP/pages/mainMg/settings/lightMonitoring/chartsData.vue";
import lightTable from "@/CommonDP/pages/mainMg/settings/lightMonitoring/lightTable.vue";
import lightService from "@/CommonDP/service/light-service";

// 初始筛选表单
function SearchForm() {
  return {
    startDate: "",
    endDate: "",
    fileTypes: [],
    fileName: ""
  };
}

export default {
  components: { chartsData, lightTable },
  data() {
    return {
      typeList: [], // 轻量化文件类型
      searchForm: new SearchForm()
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    // 绑定的筛选日期
    timeRange: {
      get() {
        const { startDate = "", endDate = "" } = this.searchForm;
        return [startDate, endDate];
      },
      set(dates) {
        if (dates?.length) {
          this.searchForm.startDate = dates[0] || "";
          this.searchForm.endDate = dates[1] || "";
        } else {
          this.searchForm.startDate = "";
          this.searchForm.endDate = "";
        }
      }
    }
  },
  mounted() {
    this.queryAllFileType();
  },
  methods: {
    // 获得筛选人员列表
    async queryAllFileType() {
      const { data } = await lightService.queryAllFileType();
      this.typeList = data || [];
    },

    // 查询
    search() {
      this.$refs.chartsData.search();
      this.$refs.lightTable.search();
    },
    // 重置
    reset() {
      this.searchForm = new SearchForm();
      this.$nextTick(()=>{
        this.search();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.lightMonitoring {
  width: 100%;
  height: 100%;
  padding: 0 var(--big-space);
}
::v-deep .searchForm {
  padding: var(--middle-space) 0 0;
}
</style>
